module.exports = __webpack_public_path__ + "media/images/game_icon/none-567fd7f4cf722cb03cf4b3d43f6e0d01.png";